import { $enum } from 'ts-enum-util'
import * as yup from 'yup'
import { FacilityPurpose } from 'apps/fleet-planner/utils/api'

export interface IShipmentStopAddress {
  addressee?: string | null
  addressLine1?: string | null
  addressLine2?: string | null
  locality?: string | null
  subdivisionCode?: string | null
  countryCode?: string | null
  postalCode?: string | null
  purpose: FacilityPurpose
}

/**
 * Schema for adding an address to a stop object
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Shipments/post_shipments
 */
export const ShipmentStopAddressSchema = yup.object<IShipmentStopAddress>({
  addressee: yup.string().notRequired().nullable(),
  addressLine1: yup.string().notRequired().nullable(),
  addressLine2: yup.string().notRequired().nullable(),
  locality: yup.string().notRequired().nullable(),
  subdivisionCode: yup.string().notRequired().nullable(),
  countryCode: yup.string().notRequired().nullable(),
  postalCode: yup.string().notRequired().nullable(),
  purpose: yup.mixed<FacilityPurpose>().oneOf([...$enum(FacilityPurpose).getValues()]),
})

export type ShipmentStopAddressSchemaType = yup.InferType<typeof ShipmentStopAddressSchema>
